import { Col } from "./Flexbox";
import Text from "./Text";
const OrdenProduccion = props => {
    
    let color = props.theme.Red;
    let message = "";
    if (props.days > 1) {
        message = `Entrega en ${props.days} días`;
        color = props.theme.Blue;
    } else if (props.days == 1) {
        message = `Entrega mañana`;
        color = props.theme.Orange;
    } else if (props.days == 0) {
        message = `Entrega hoy`;
        color = props.theme.Orange;
    } else {
        color = props.theme.Red;
        if (props.days == 1) {
            message = `${Math.abs(props.days)} día de retraso`;
        } else {
            message = `${Math.abs(props.days)} días de retraso`;
        }
        
    }
    
    const styles = {
        mainContainer: {
            flex: 'none',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            width:129,
            height: 98,
            border: 'solid 1px',
            borderColor: color,
            borderRadius: 4,
            padding: 18,
            backgroundColor: `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, 0.07)`,
            
        },
        textContainers: {
            alignItems:'flex-start',
            flex:'none'
        },
        clientName: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            maxWidth: 90,
        }
    }
    
    return (
        <Col style={{...styles.mainContainer, ...props.mainContainerStyle}}>
            <Col style={{...styles.textContainers, ...props.textContainersStyle}}>
                <Text style={{...styles.clientName, ...props.clientNameStyle}} weight="light" color={color} size={11}>{props.clientName}</Text>
                <Text weight="extrabold" color={color} size={15}>{props.orderID}</Text>
            </Col>
            <Col style={{...styles.textContainers, ...props.textContainersStyle}}>
                <Text weight="medium" color={color} size={11}>{message}</Text>
            </Col>
        </Col>
    )
}

export default OrdenProduccion;